// components/Pricings.tsx
import React from 'react';
import TwoYearPlan from '../components/Pricings/TwoYearPlan';
import AnnualPlan from '../components/Pricings/AnnualPlan';
import { Link } from 'react-router-dom';
import PriceFeatures from '../components/common/PriceFeatures';
import everGrowingCourseCatalog from '../assets/images/features/Ever_Growing_Course_Catalog.jpg';
import handsOnLearning from '../assets/images/features/100_Hands_On_Learning.jpg';

interface PricingsProps {
  plan: 'annual' | 'two-year';
}

const Pricings: React.FC<PricingsProps> = ({ plan }) => {
  const isTwoYearPlan = plan === 'two-year';

  return (
    <div className="bg-gradient-to-r from-pink-200 to-blue-300 py-4">
      <div className="max-w-md mx-auto p-6 bg-white rounded-lg shadow-lg border border-gray-300">
        <div className="bg-red-500 text-white text-center py-2 rounded-t-md font-semibold text-lg">
          50% OFF
        </div>

        <div className="text-center mt-4">
          {isTwoYearPlan ? <TwoYearPlan /> : <AnnualPlan />}
        </div>

        <div className="text-center mt-4">
          <Link
            to="/signup"
            className="text-[24px] hover:text-yellow-300 transition-colors hover:no-underline"
          >
            <button className="w-full bg-indigo-600 text-white py-2 rounded-md font-semibold text-lg">
              Get Started
            </button>
          </Link>
        </div>

        <div className="mt-4 text-center">
          <Link to={isTwoYearPlan ? '/pricing/annually' : '/pricing/twoyears'}>
            <button className="ml-2 text-sm text-indigo-600 bg-indigo-100 px-2 py-1 rounded-md">
              {isTwoYearPlan ? 'Choose Annual Plan' : 'Choose 2-year plan'}
            </button>
            {!isTwoYearPlan && (
              <span className="ml-2 text-sm bg-yellow-400 text-white px-3 py-1 rounded-md font-semibold">
                SAVE 10%
              </span>
            )}
          </Link>
        </div>
      </div>
      {/* <PricingList isTwoYearPlan={isTwoYearPlan} /> */}
      <PriceFeatures />

      {/* Images Section */}
      <div className="mt-12 px-4">
        <div className="flex flex-col lg:flex-row justify-center items-center gap-8 lg:gap-12">
          <div className="flex-shrink-0 transform hover:scale-110 transition-transform duration-300 hover:rotate-2">
            <div className="bg-gradient-to-br from-blue-100 to-purple-100 p-4 rounded-3xl shadow-xl border-4 border-blue-200">
              <img
                src={everGrowingCourseCatalog}
                alt="Ever Growing Course Catalog"
                className="w-[40rem] h-auto rounded-2xl shadow-lg"
              />
              <div className="mt-4 text-center">
                <h3 className="text-2xl font-bold text-blue-600 mb-2">
                  📚 Fun Courses for Kids!
                </h3>
                <p className="text-gray-600 font-medium">
                  Lots of exciting coding adventures! 🚀
                </p>
              </div>
            </div>
          </div>

          <div className="flex-shrink-0 transform hover:scale-110 transition-transform duration-300 hover:-rotate-2">
            <div className="bg-gradient-to-br from-green-100 to-yellow-100 p-4 rounded-3xl shadow-xl border-4 border-green-200">
              <img
                src={handsOnLearning}
                alt="100 Hands On Learning"
                className="w-[40rem] h-auto rounded-2xl shadow-lg"
              />
              <div className="mt-4 text-center">
                <h3 className="text-2xl font-bold text-green-600 mb-2">
                  💻 Hands-On Learning!
                </h3>
                <p className="text-gray-600 font-medium">
                  Learn by doing cool projects! ⭐
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Pricings;
